import React from 'react';
import Icon from '../Icon';
import * as styles from './GeneratorCard.module.scss';
import logo from './logo-v3.svg';
import * as htmlToImage from 'html-to-image';
import { toPng } from 'html-to-image';
import { isMobile } from 'react-device-detect';
import { imageIcon } from '../../utilities/icons';
import Button from '../Button';

interface GeneratorCardProps {
    type: string,
    name: string,
    icon: string,
    attributes: AttributeProps[],
}

interface AttributeProps {
    name: string,
    value: string,
}

const GeneratorCard = ({ type, icon, name, attributes }: GeneratorCardProps) => {
    const generateCardImage = () => {
        htmlToImage.toPng(document.getElementById('generatorCard'))
        .then(function (dataUrl) {
            let link = document.createElement('a');
            link.href = dataUrl;
            link.download = `${name.replaceAll(' ', '-').toLowerCase()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }
    return (
        <div>
            <div id="generatorCard" className={styles.generatorCard}>
                <div className={styles.generatorCardMain}>
                    <div className={styles.generatorCardHeader}>
                        <img src={logo} alt="Generator Ninja Logo" width={150} />
                        <span>{type}</span>
                    </div>
                    <div className={styles.generatorCardSubHeader}>
                        <Icon icon={icon} style={styles.icon} />
                        <span>{name}</span>
                    </div>
                    <div className={styles.generatorCardAttributes}>
                        {attributes.map((attr) =>
                            <div key={`${attr.name}_${attr.value}`} className={`${styles.attribute} ${attr.value.length > 0 ? '' : styles.hidden}`}>
                                <div className={styles.attributeName}>{attr.name}:</div>
                                <div className={styles.attributeValue}>{attr.value}</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {isMobile ? '' : <Button icon={imageIcon} type="Function" text={`Download ${type} Card`} light={true} handleClick={generateCardImage} />}
        </div>
    )
}

export default GeneratorCard;
